"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _default = Object.assign({}, _react.Children, {
  filter: function filter(children, filterFn) {
    return _react.Children.toArray(children).filter(filterFn);
  }
});

exports["default"] = _default;